import { Edit, Trash } from 'lucide-react';
import React, { useState, useEffect } from 'react';
import CustomOffCanvas from '../../components/CustomOffCanvas';
import CustomPageHeader from '../../components/CustomPageHeader';
import { useNavigate } from 'react-router-dom';
import Spinner from '../../components/Spinner';
import Pagination from '../../components/Pagination';
import { Apirequests } from '../../utils/ApiRequests';
import { ErrorTost, SuccessTost } from '../../utils/ToastHelper';
import moment from 'moment';
import AddUser from './AddUser';
import EditUser from './EditUser';
import BtnSpinner from '../../components/BtnSpinner';
import { downloadExcel } from '../../utils/DownloadXls';
import UserEnrollments from './UserEnrollments';

// Dummy user data
// const dummyUsers = [
//   { id: 1, name: 'John Doe', email: 'john@example.com', role: 'Admin' },
//   { id: 2, name: 'Jane Smith', email: 'jane@example.com', role: 'User' },
//   { id: 3, name: 'Bob Johnson', email: 'bob@example.com', role: 'Editor' },
//   { id: 4, name: 'Alice Brown', email: 'alice@example.com', role: 'User' },
//   { id: 5, name: 'Charlie Davis', email: 'charlie@example.com', role: 'Admin' },
// ];

const Users = () => {
  const [isOffCanvasOpen, setIsOffCanvasOpen] = useState({ state: false, name: "" });
  const [users, setUsers] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState({ state: false, name: "" });
  const [currentPage, setCurrentPage] = useState(1);
  const [refresh, setRefresh] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [deleteId, setdeleteId] = useState(null)

  const token = localStorage.getItem("token");


  const totalItems = users?.length; // Total number of items
  const itemsPerPage = 20;

  const currentData = users?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const navigate = useNavigate();

  const handleRefresh = () => setRefresh(!refresh);


  const handleSearch = async () => {
    if (!searchTerm) {
      return ErrorTost("Enter a key to serach")
    }

    if(currentPage!==1){
      setCurrentPage(1)
    }

    // console.log('term',searchTerm,'search')
    await fetchUsers(searchTerm)
  };


  const fetchUsers = async () => {
    setLoading({ state: true, name: 'fetchuser' })
    try {
      const userRes = await Apirequests(`users/get-users?q=${searchTerm}`,
        "GET",
        {},
        {
          Authorization: `Bearer ${token}`,
        });
      if (userRes?.success) {
        setUsers(userRes?.data)
      }
    } catch (error) {
      console.log(error, 'fetch users error');
      return ErrorTost("Something went wrong. Try again later.")
    }
    setLoading({ state: false, name: "" })
  }


  const handleDeleteUser = async (userid) => {
    setdeleteId(userid)
    setLoading({ state: true, name: 'deleteuser' })
    try {
      const res = await Apirequests(`users/delete-user/${userid}`, 'DELETE', {}, {
        Authorization: `Bearer ${token}`
      });
      // console.log(res,'deleteres');

      if (res?.success) {
        setRefresh(!refresh)
        SuccessTost(res?.message)
      } else {
        ErrorTost(res?.message)
      }
    } catch (error) {
      console.log("delete user frontent error", error);
      ErrorTost("Something went wrong , please try again later")
    }
    setLoading({ state: false, name: "" })
  }


  useEffect(() => {
    fetchUsers()
  }, [token, refresh]);







  if (loading.state && loading.name === "fetchuser") {
    return <div className='h-screen w-full flex items-center justify-center bg-[rgba(255,255,255,0.5)]'>
      <Spinner />
    </div>
  }

  return (
    <div className="min-h-screen bg-gray-100">
      {/* <header className="bg-white shadow">
        <div className="mx-auto py-6 px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            <h1 className="text-3xl font-bold text-gray-900 mb-4 md:mb-0">User Listing</h1>
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search users..."
                  className="border rounded-md px-4 py-2 w-full sm:w-64"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <Search className="text-indigo-700 absolute right-2 top-[50%] translate-y-[-50%]"/>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={handleBackClick}
                  className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded"
                >
                  Back
                </button>
                <button
                  onClick={() => setIsOffCanvasOpen(true)}
                  className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
                >
                  Add User
                </button>
              </div>
            </div>
          </div>
        </div>
      </header> */}

      <CustomPageHeader
        title={"Users List"}
        text={searchTerm}
        setText={setSearchTerm}
        handleSearch={handleSearch}
        onClick={() => setIsOffCanvasOpen({ state: true, name: "adduser" })}
        btnText={"Add User"}
        handleBackClick={() => navigate("/")}
        handleRefresh={handleRefresh}
        handleDownload={() => downloadExcel(users, 'users')}
      />

      <main className="mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white">
              <thead className="bg-gray-50 text-center">
                <tr>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Phone</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Enrollments</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Role</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Created At</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 text-center">
                {currentData?.map((user) => (
                  <tr key={user.id}>

                    <td className="px-6 py-4 whitespace-nowrap">{user?.name}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{user?.email}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{user?.phone}</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {user?.user_type !== "admin" ? <button className='text-indigo-500' onClick={() => { setIsOffCanvasOpen({ state: true, name: "showenroll" }); setCurrentUser(user) }}>View/Edit</button> : null}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">{user.user_type}</td>
                    {/* <td className="px-6 py-4 whitespace-nowrap">
                      <p className='bg-green-200 text-center rounded-full py-1'>active</p>
                    </td> */}
                    <td className="px-6 py-4 whitespace-nowrap">{moment(user?.createdAt).format("Do-MMM-YY hh:mm")}</td>
                    <td className="px-6 py-4 flex gap-5 justify-center">
                      <button className='flex bg-indigo-400 rounded-lg px-3 py-2 items-center gap-1' onClick={() => { setIsOffCanvasOpen({ state: true, name: "edituser" }); setCurrentUser(user) }}>
                        <Edit className='text-white' size={20} />
                        <span className='text-white text-sm'>Edit</span>
                      </button>
                      <button className='flex bg-red-200 rounded-lg px-3 py-2 items-center gap-1' onClick={() => handleDeleteUser(user?._id)}>
                        {
                          loading.state && loading.name === "deleteuser" && deleteId === user?._id ?
                            <BtnSpinner /> :
                            <>
                              <Trash className='text-red-700 text-sm' size={20} />
                              <span className='text-red-700 text-sm'>Delete</span>
                            </>
                        }

                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {users?.length ?
          <div className="flex gap-x-2 items-center justify-between">
            <p>total: {users?.length}</p>
            <Pagination
              page={currentPage}
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              onPageChange={handlePageChange}
            />
          </div> : null}
      </main>

      {/* Off-canvas overlay with animation */}
      {/* <div 
        className={`fixed inset-0 overflow-hidden z-50 transition-opacity duration-300 ${
          isOffCanvasOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
      >
        <div className="absolute inset-0 overflow-hidden">
          <div 
            className={`absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity duration-300 ${
              isOffCanvasOpen ? 'opacity-100' : 'opacity-0'
            }`} 
            onClick={() => setIsOffCanvasOpen(false)}
          />
          <section className="absolute inset-y-0 right-0 pl-10 max-w-full flex">
            <div 
              className={`w-screen max-w-md transform transition-transform duration-300 ease-in-out ${
                isOffCanvasOpen ? 'translate-x-0' : 'translate-x-full'
              }`}
            >
              <div className="h-full flex flex-col bg-white shadow-xl">
                <div className="flex-1 py-6 overflow-y-auto px-4 sm:px-6">
                  <div className="flex items-start justify-between">
                    <h2 className="text-lg font-medium text-gray-900">Add User</h2>
                    <button
                      onClick={() => setIsOffCanvasOpen(false)}
                      className="ml-3 h-7 flex items-center justify-center"
                    >
                      <span className="sr-only">Close panel</span>
                      <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                  <div className="mt-8">
                    <p>Add user form placeholder</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div> */}
      <CustomOffCanvas
        open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "adduser"}
        close={() => setIsOffCanvasOpen({ state: false, name: "" })}
        content={
          <AddUser
            close={() => setIsOffCanvasOpen({ state: false, name: "" })}
            setRefresh={setRefresh}
          />
        }
      />

      <CustomOffCanvas
        open={isOffCanvasOpen.state && isOffCanvasOpen.name === "edituser"}
        close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentUser(null) }}
        content={
          <EditUser
            close={() => setIsOffCanvasOpen({ state: false, name: "" })}
            setRefresh={setRefresh}
            user={currentUser}
          />
        }
      />

      <CustomOffCanvas
        open={isOffCanvasOpen.state && isOffCanvasOpen.name === "showenroll"}
        close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentUser(null) }}
        content={
          <UserEnrollments user={currentUser} close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentUser(null) }} setRefresh={setRefresh} />
        }
      />
    </div>
  );
};

export default Users;